import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=58581b0c&scoped=true&"
import script from "./cookie-banner.vue?vue&type=script&lang=ts&"
export * from "./cookie-banner.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-banner.vue?vue&type=style&index=0&id=58581b0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58581b0c",
  null
  
)

export default component.exports